import AccountVisibilityOptions from "../interfaces/AccountVisibilityOptions";
import INPUT_VALIDATION_TYPES_AC_INTERFACE from "../interfaces/INPUT_VALIDATION_TYPES_AC_INTERFACE";

export const INPUT_VALIDATION_TYPES_AC: INPUT_VALIDATION_TYPES_AC_INTERFACE = {
  bankAccountNumber: "digits",
  bankRoutingNumber: "digits",
  startDate: "date",
  operationsStartDate: "date",
  operationsEndDate: "date",
  monthlyFcrExpense: "money-optional-sign",
  monthlyArmoredCarFee: "money-optional-sign",
  touchTonePhoneNumber: "phone",
  touchToneGenericQuestions: "phone",
  touchToneOrderDeadline: "12hour-timestamp",
  ceoOrderDeadline: "12hour-timestamp",
  armoredCarServicingDays: "weekdays",
};

export const INPUT_VALIDATION_TYPES_DP = {
  defaultCommissionRate: "percent",
  defaultCommissionFee: "money",
  deliveryPartnerId: "digits",
  grossSalesTransactionCode: "digits",
  commissionTransactionCode: "digits",
};

export const VALID_TIME_FORMATS = {
  "12hour-timestamp": "h:mm A",
  "iso-timestamp": "HH:mm:ss",
  // Square brackets [] used to escape [Z]
  "iso-datetime": "YYYY-MM-DDTHH:mm:ss.SSS[Z]",
  "iso-date": "YYYY-MM-DD",
};

export let ARMORED_CAR_DEFAULT_VALUES = {
  bankName: "Wells Fargo",
  bankRoutingNumber: "121000248",
  oracleBankChange: true,
  changeOrderingLeadDays: 1,
  hasSmartSafe: true,
  safeSize: "N/A",
  smartSafeSleeve: false,
  armoredCarService: "Loomis",
  ceoCompanyId: "CHICF283",
  ceoOrderDeadline: "10:30 AM",
  touchToneOrderDeadline: "11:00 AM",
  touchTonePhoneNumber: "844-831-2129",
  operatorEmptyName: "Operator Name Unavailable",
};

export const ARMORED_CAR_ACCOUNT_VISIBILITY_OPTIONS: AccountVisibilityOptions =
  {
    activeAccount: ["Active Accounts", "No Active Accounts"],
    smartSafe: ["Smart Safes", "No Smart Safes"],
    companyOwned: ["Company Owned", "Not Company Owned"],
  };

export const CREATE_BU_LOCATION_NAME_DEFAULT_VALUE = "User_Created_Default";
